var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInst3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 81,
    viewBox: "0 0 102 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 39L69.1865 70.5H32.8135L51 39Z",
    fill: "url(#paint0_linear_52_2202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 0L69.1865 31.5H32.8135L51 0Z",
    fill: "url(#paint1_linear_52_2202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7835 3.71117L33.8987 5.91081L35.1556 7.92112L32.7902 7.75939L31.2667 9.57601L30.6896 7.27641L28.4911 6.38883L30.4998 5.12934L30.6645 2.76417L32.4831 4.28535L34.7835 3.71117Z",
    fill: "#D1BE4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7835 53.7112L34.8987 55.9108L36.1556 57.9211L33.7902 57.7594L32.2667 59.576L31.6896 57.2764L29.4911 56.3888L31.4998 55.1293L31.6645 52.7642L33.4831 54.2853L35.7835 53.7112Z",
    fill: "#D1BE4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7835 42.7112L63.8987 44.9108L65.1556 46.9211L62.7902 46.7594L61.2667 48.576L60.6896 46.2764L58.4911 45.3888L60.4998 44.1293L60.6645 41.7642L62.4831 43.2853L64.7835 42.7112Z",
    fill: "#D1BE4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78345 40.7112L6.89869 42.9108L8.1556 44.9211L5.79022 44.7594L4.26671 46.576L3.68958 44.2764L1.49108 43.3888L3.49978 42.1293L3.66455 39.7642L5.48312 41.2853L7.78345 40.7112Z",
    fill: "#D1BE4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5457 9.49218L68.3242 11.7316L70.5926 12.4211L68.7033 13.8535L68.7486 16.224L66.8025 14.8698L64.562 15.6454L65.2486 13.376L63.8186 11.4849L66.189 11.4366L67.5457 9.49218Z",
    fill: "#D1BE4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5454 13.4922L87.3239 15.7316L89.5924 16.4211L87.7031 17.8535L87.7484 20.224L85.8023 18.8698L83.5618 19.6454L84.2483 17.376L82.8183 15.4849L85.1888 15.4366L86.5454 13.4922Z",
    fill: "#D1BE4E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1284 20.0178L73.4929 21.0665L74.5551 21.3893L73.6704 22.0601L73.6916 23.1701L72.7803 22.536L71.7312 22.8992L72.0527 21.8365L71.3831 20.951L72.4931 20.9283L73.1284 20.0178Z",
    fill: "#D1BE4E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1284 7.23047L86.4929 8.27915L87.5551 8.60199L86.6704 9.27275L86.6916 10.3828L85.7803 9.74864L84.7312 10.1118L85.0527 9.04917L84.3831 8.16361L85.4931 8.14097L86.1284 7.23047Z",
    fill: "#D1BE4E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.128 5.23047L100.493 6.27915L101.555 6.60199L100.67 7.27275L100.692 8.38277L99.7803 7.74864L98.7312 8.11183L99.0527 7.04917L98.3831 6.16361L99.4931 6.14097L100.128 5.23047Z",
    fill: "#D1BE4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1286 53.2305L83.4931 54.2792L84.5554 54.602L83.6707 55.2727L83.6919 56.3828L82.7806 55.7486L81.7314 56.1118L82.0529 55.0492L81.3833 54.1636L82.4933 54.141L83.1286 53.2305Z",
    fill: "#D1BE4E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1286 34.2305L72.4931 35.2792L73.5554 35.602L72.6707 36.2727L72.6919 37.3828L71.7806 36.7486L70.7314 37.1118L71.0529 36.0492L70.3833 35.1636L71.4933 35.141L72.1286 34.2305Z",
    fill: "#D1BE4E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1286 52.2305L11.4931 53.2792L12.5554 53.602L11.6707 54.2727L11.6919 55.3828L10.7806 54.7486L9.73144 55.1118L10.0529 54.0492L9.3833 53.1636L10.4933 53.141L11.1286 52.2305Z",
    fill: "#D1BE4E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1286 44.2305L16.4931 45.2792L17.5554 45.602L16.6707 46.2727L16.6919 47.3828L15.7806 46.7486L14.7314 47.1118L15.0529 46.0492L14.3833 45.1636L15.4933 45.141L16.1286 44.2305Z",
    fill: "#D1BE4E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1286 59.2305L29.4931 60.2792L30.5554 60.602L29.6707 61.2727L29.6919 62.3828L28.7806 61.7486L27.7314 62.1118L28.0529 61.0492L27.3833 60.1636L28.4933 60.141L29.1286 59.2305Z",
    fill: "#D1BE4E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1286 34.2305L62.4931 35.2792L63.5554 35.602L62.6707 36.2727L62.6919 37.3828L61.7806 36.7486L60.7314 37.1118L61.0529 36.0492L60.3833 35.1636L61.4933 35.141L62.1286 34.2305Z",
    fill: "#D1BE4E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3057 58.3517L18.4048 58.1953L18.9256 57.2148L19.414 58.2118L20.5075 58.4042L19.7102 59.1768L19.8651 60.2761L18.884 59.7566L17.8863 60.2437L18.0772 59.15L17.3057 58.3517Z",
    fill: "#D1BE4E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5464 46.5924L40.6455 46.436L41.1663 45.4555L41.6547 46.4526L42.7482 46.6449L41.9509 47.4175L42.1059 48.5168L41.1247 47.9973L40.1271 48.4844L40.318 47.3907L39.5464 46.5924Z",
    fill: "#D1BE4E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5464 36.5924L56.6455 36.436L57.1663 35.4555L57.6547 36.4526L58.7482 36.6449L57.9509 37.4175L58.1059 38.5168L57.1247 37.9973L56.1271 38.4844L56.318 37.3907L55.5464 36.5924Z",
    fill: "#D1BE4E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5464 48.5924L26.6455 48.436L27.1663 47.4555L27.6547 48.4526L28.7482 48.6449L27.9509 49.4175L28.1059 50.5168L27.1247 49.9973L26.1271 50.4844L26.318 49.3907L25.5464 48.5924Z",
    fill: "#D1BE4E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1284 13.2305L78.4929 14.2792L79.5551 14.602L78.6704 15.2727L78.6916 16.3828L77.7803 15.7486L76.7312 16.1118L77.0527 15.0492L76.3831 14.1636L77.4931 14.141L78.1284 13.2305Z",
    fill: "#D1BE4E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_2202",
    x1: 64.4517,
    y1: 75.2903,
    x2: 72.7994,
    y2: 30.4383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAC49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_2202",
    x1: 64.4517,
    y1: 36.2903,
    x2: 72.7994,
    y2: -8.56171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAC49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst3);
export default __webpack_public_path__ + "static/media/inst3.7ec9e83ccea1220b1ae8103a50cf942d.svg";
export { ForwardRef as ReactComponent };